<template>
  <LISAEisenHowerMatrix
    v-if="isLISA3"
    v-bind="{ ...$attrs, ...$props, 'onUpdate:modelValue': undefined }"
    v-model="eisenhowerPriority"
  />
  <div
    v-if="isLISA3 === false && showEisenhowerPriority === true && showChip !== true"
    :class="[getEisenhowerClass(eisenhowerPriority), { 'p-disabled': disabled }]"
    class="w-100 inputStyle"
    @click="toggleVisibility()"
  >
    <i :class="getEisenhowerIconClass(eisenhowerPriority)"></i>
    <span class="text-truncate ml-1">{{
      t(`components.eventAction.filter.badges.PriorityFilter.${eisenhowerPriority}`)
    }}</span>
  </div>
  <Chip
    v-else-if="isLISA3 === false && showEisenhowerPriority === true && showChip"
    style="gap: 0"
    class="mr-1 chipStyleEAB"
    :class="[
      getEisenhowerClass(eisenhowerPriority),
      disabled === false ? 'cursor-pointer' : 'cursor-default',
    ]"
    @click="toggleVisibility()"
  >
    <i :class="getEisenhowerIconClass(eisenhowerPriority)"></i>
    <span class="text-truncate ml-1">{{
      t(`components.eventAction.filter.badges.PriorityFilter.${eisenhowerPriority}`)
    }}</span>
  </Chip>
  <EisenhowerMatrixModal
    v-if="showEisenhowerModal"
    v-model="showEisenhowerModal"
    v-model:priority="eisenhowerPriority"
    :update-event-directly="updateEventDirectly"
  />
</template>

<script setup lang="ts">
import { type PropType, ref } from "vue";
import { getEisenhowerClass, getEisenhowerIconClass } from "../EventHelper";
import EisenhowerMatrixModal from "./EisenhowerMatrixModal.vue";
import { EisenhowerPriority } from "@/graphql";
import Chip from "primevue/chip";
import { LISAEisenHowerMatrix } from "@fi-solutions/lisa-ui";
import { useTranslation } from "@/language/translation.ts";
import { useSQDCGlobalSettings } from "@/modules/sqdc/helper/useSQDCGlobalSettings.ts";
import { isLISA3 } from "@/composables/useLISA3.ts";

const { t } = useTranslation();

defineOptions({
  inheritAttrs: false,
});
const showEisenhowerModal = ref(false);

const props = defineProps({
  updateEventDirectly: {
    type: Object as PropType<
      | {
          eventType: string;
          eventId: number;
        }
      | undefined
    >,
    required: false,
    default: undefined,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  showChip: {
    type: Boolean,
    required: false,
    default: false,
  },
});
function toggleVisibility() {
  if (props.disabled === false) {
    showEisenhowerModal.value = true;
  }
  return;
}

const eisenhowerPriority = defineModel({
  type: String as PropType<EisenhowerPriority | undefined>,
  default: undefined,
});

const { showEisenhowerPriority } = useSQDCGlobalSettings();
</script>

<style lang="scss" scoped>
.inputStyle {
  padding: var(--p-multiselect-padding-y) var(--p-multiselect-padding-x) !important;
  border: 1px solid var(--p-multiselect-border-color) !important;
  border-radius: var(--p-border-radius-md) !important;
}
.inputStyle:hover {
  cursor: pointer;
}
.chipStyleEAB {
  font-size: 0.855em !important;
  padding: 0.5em !important;
  line-height: 1 !important;
  font-weight: normal !important;
}
</style>
